import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';
import { Skeleton } from '@/components/ui/Skeleton';
import { useAdminCampaigns, useSendCampaign } from '@/hooks/useAdminCommunications';
import { formatDateTime, formatPercentage } from '@/utils/formatters';
import { Mail, Send } from 'lucide-react';

export function EmailCampaignsPage() {
  const { data, isLoading } = useAdminCampaigns({});
  const send = useSendCampaign();
  const campaigns = data?.data?.data || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Campagnes email</h1><p className="text-sm text-neutral-500">Envoi d'emails en masse</p></div>
      </div>

      {isLoading ? <Skeleton className="h-64" /> : campaigns.length === 0 ? (
        <EmptyState message="Aucune campagne" icon={<Mail className="h-10 w-10" />} />
      ) : (
        <div className="space-y-3">
          {campaigns.map((c) => (
            <Card key={c.uuid}>
              <CardContent>
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-medium text-neutral-900 dark:text-neutral-200">{c.subject}</h3>
                    <div className="mt-1 flex items-center gap-3 text-xs text-neutral-500">
                      <span>{c.recipientCount} destinataires</span>
                      {c.sentAt && <span>Envoyé le {formatDateTime(c.sentAt)}</span>}
                      {c.openRate > 0 && <span>Ouverture: {formatPercentage(c.openRate)}</span>}
                      {c.clickRate > 0 && <span>Clics: {formatPercentage(c.clickRate)}</span>}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant={c.status === 'sent' ? 'success' : c.status === 'draft' ? 'neutral' : 'warning'}>{c.status}</Badge>
                    {c.status === 'draft' && (
                      <Button variant="outline" size="sm" icon={<Send className="h-3 w-3" />} onClick={() => send.mutate(c.uuid)} loading={send.isPending}>
                        Envoyer
                      </Button>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
